import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dealers } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { GetDealer } from './interface';

export const getDealer = createAsyncThunk(
  'dealers/getDealer',
  async (values: GetDealer, { rejectWithValue }) => {
    try {
      const response = await Dealers.get(values.id);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);